import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useProfile } from 'context/Profile'

const Guard = ( {
  children
} ) => {
  const profile = useProfile()
  const navigate = useNavigate()

  useEffect( () => {
    if ( ! profile.user )
      return navigate( '/info' )
  }, [ profile.user ] )

  if ( ! profile.user )
    return null

  return children
}

export default Guard
